<template>
    <div>
        <!-- Étape 1 -->
        <h1 v-if="step.id === 1" class="step_title_content ppv2-text-black" :style="{ fontSize: sizes.title }">
            {{ step.content }}
        </h1>

        <!-- Autres étapes -->
        <div v-if="step.id === 2" class="form-header">
            <h2 class="form-step ppv2-text-black" :style="{ fontSize: sizes.formStep }">
                {{ $t('experience.step') }} {{ step.stepNumber }}
            </h2>
            <h1 class="step_title_content text-left ppv2-text-black" :style="{ fontSize: sizes.title }">
                {{ step.content }}
            </h1>
        </div>
        <div v-if="step.id !== 1 && step.id !== 2" class="form-header">
            <h2 class="form-step ppv2-text-black" :style="{ fontSize: sizes.formStep }">
                {{ $t('experience.step') }} {{ step.stepNumber }}
            </h2>
            <h1 class="step_title_content text-left ppv2-text-black" :style="{ fontSize: sizes.title }">
                {{ step.subtitle }}
            </h1>

            <p
                class="ppv2-text-black poppinsRegular !ppv2-mb-0"
                :style="{ fontSize: normalizeFontSize(14), marginTop: normalizeSizeVertical(36, true) }"
                v-if="step.content"
            >
                {{ step.content }}
            </p>
            <p class="ppv2-text-black poppinsRegular" v-if="step.sub_content" :style="{ fontSize: normalizeFontSize(13) }">
                {{ step.sub_content }}
            </p>
            <ProBanner v-if="step.id === 6" type="Pro" />
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../../../utils/normalizeSize'
import normalizeSizeVertical from '../../../../utils/normalizeSizeVertical'
import { Star } from 'lucide-vue'
import ProBanner from '../../../Shared/ProBanner.vue'
import normalizeFontSize from '../../../../utils/normalizeFontSize'

export default {
    name: 'Header',
    components: { Star, ProBanner },
    methods: {
        normalizeSizeVertical,
        normalizeSize,
        normalizeFontSize,
    },
    props: {
        step: { type: Object, required: true },
        sizes: { type: Object, required: true },
    },
}
</script>

<style scoped>
.step_title_content {
    font-family: 'Poppins Light', sans-serif !important;
    margin-bottom: 0 !important;
}
.form-header {
    margin-bottom: 40px;
}
.form-step {
    text-transform: uppercase;
    margin-bottom: 6px;
}
</style>
